<script>
  import { onMount } from "svelte";
  import { Howl, Howler } from "howler";
  import { fade, fly } from "svelte/transition";
  import Info from "./Info.svelte";
  import Modal from "svelte-simple-modal";
  import data from "./data.js";
  //import Slider from "@smui/slider";

  var sound = new Howl({
    src: ["/haltara.mp3"],
    volume: 0.5,
    ext: ["mp3"],
    autoplay: false,
    html5: true
  });
  let second = 0;
  let caption;
  let img;
  let captionIndex;
  let length;

  let x;
  let playing = false;

  function togglePlay() {
    playing = !playing;
    if (!playing) {
      sound.pause();
    } else {
      sound.play();
    }
  }
  sound.on("load", () => {
    length = sound.duration();
    console.log(sound.duration());
  });
  setInterval(() => {
    second = parseInt(sound.seek());
    caption = data.find(d => second >= d.from && second <= d.to);
    captionIndex = data.findIndex(d => second >= d.from && second <= d.to);
    console.log(caption);
    if (caption && caption.pic) {
      if (caption.pic != x) {
        x = caption.pic;
      }
    }
  }, 500);
  onMount(() => {});
  function handleKeydown(e) {
    if (e.keyCode == 39) {
      const inc = captionIndex + 1;
      const pos = data[inc];
      console.log(inc, pos);
      sound.seek(pos.to);
    }
    if (e.keyCode == 32) {
      togglePlay();
    }
  }
  function jump(e) {
    const sec = parseInt(e.target.value);
    sound.seek(sec);
  }
  data
    .filter(d => d.pic != undefined)
    .forEach(d => {
      var img = new Image();
      img.src = `/${d.pic}.jpg`;
    });
</script>

<style>
  * {
    color: white;
  }
  .ar {
    direction: rtl;
    font-family: "Cairo", "Amiri", sans-serif;
    text-shadow: 1px 1px 2px #000;
  }
  .dv {
    direction: rtl;
    font-family: "mvtyper", sans-serif;
    text-shadow: 1px 1px 2px #000;
  }
  h4 {
    margin-bottom: 20px;
    line-height: 50px;
  }
  .c {
    text-align: center;
    display: grid;

    grid-template-areas:
      "header"
      "nav"
      "footer";

    grid-template-rows: 100px 1fr 200px;

    height: 90vh;
  }
  .btn-group-sm > .btn,
  .btn-sm {
    border-radius: 2.2rem;
  }
  .play-btn {
    width: 60px;

    height: 60px;

    padding: 6px 0px;

    border-radius: 30px;

    text-align: center;
  }

  .range {
    -webkit-appearance: none;
    -moz-appearance: none;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 200px;
    margin-top: 10px;
    transform: translate(-50%, -50%);
  }

  input[type="range"]::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    background: rgba(59, 173, 227, 1);
    background: -moz-linear-gradient(
      45deg,
      rgba(59, 173, 227, 1) 0%,
      rgba(87, 111, 230, 1) 25%,
      rgba(152, 68, 183, 1) 51%,
      rgba(255, 53, 127, 1) 100%
    );
    background: -webkit-gradient(
      left bottom,
      right top,
      color-stop(0%, rgba(59, 173, 227, 1)),
      color-stop(25%, rgba(87, 111, 230, 1)),
      color-stop(51%, rgba(152, 68, 183, 1)),
      color-stop(100%, rgba(255, 53, 127, 1))
    );
    background: -webkit-linear-gradient(
      45deg,
      rgba(59, 173, 227, 1) 0%,
      rgba(87, 111, 230, 1) 25%,
      rgba(152, 68, 183, 1) 51%,
      rgba(255, 53, 127, 1) 100%
    );
    background: -o-linear-gradient(
      45deg,
      rgba(59, 173, 227, 1) 0%,
      rgba(87, 111, 230, 1) 25%,
      rgba(152, 68, 183, 1) 51%,
      rgba(255, 53, 127, 1) 100%
    );
    background: -ms-linear-gradient(
      45deg,
      rgba(59, 173, 227, 1) 0%,
      rgba(87, 111, 230, 1) 25%,
      rgba(152, 68, 183, 1) 51%,
      rgba(255, 53, 127, 1) 100%
    );
    background: linear-gradient(
      45deg,
      rgba(59, 173, 227, 1) 0%,
      rgba(87, 111, 230, 1) 25%,
      rgba(152, 68, 183, 1) 51%,
      rgba(255, 53, 127, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#3bade3 ', endColorstr='#ff357f ', GradientType=1 );
    height: 2px;
  }

  input[type="range"]:focus {
    outline: none;
  }

  input[type="range"]::-moz-range-track {
    -moz-appearance: none;
    background: rgba(59, 173, 227, 1);
    background: -moz-linear-gradient(
      45deg,
      rgba(59, 173, 227, 1) 0%,
      rgba(87, 111, 230, 1) 25%,
      rgba(152, 68, 183, 1) 51%,
      rgba(255, 53, 127, 1) 100%
    );
    background: -webkit-gradient(
      left bottom,
      right top,
      color-stop(0%, rgba(59, 173, 227, 1)),
      color-stop(25%, rgba(87, 111, 230, 1)),
      color-stop(51%, rgba(152, 68, 183, 1)),
      color-stop(100%, rgba(255, 53, 127, 1))
    );
    background: -webkit-linear-gradient(
      45deg,
      rgba(59, 173, 227, 1) 0%,
      rgba(87, 111, 230, 1) 25%,
      rgba(152, 68, 183, 1) 51%,
      rgba(255, 53, 127, 1) 100%
    );
    background: -o-linear-gradient(
      45deg,
      rgba(59, 173, 227, 1) 0%,
      rgba(87, 111, 230, 1) 25%,
      rgba(152, 68, 183, 1) 51%,
      rgba(255, 53, 127, 1) 100%
    );
    background: -ms-linear-gradient(
      45deg,
      rgba(59, 173, 227, 1) 0%,
      rgba(87, 111, 230, 1) 25%,
      rgba(152, 68, 183, 1) 51%,
      rgba(255, 53, 127, 1) 100%
    );
    background: linear-gradient(
      45deg,
      rgba(59, 173, 227, 1) 0%,
      rgba(87, 111, 230, 1) 25%,
      rgba(152, 68, 183, 1) 51%,
      rgba(255, 53, 127, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#3bade3 ', endColorstr='#ff357f ', GradientType=1 );
    height: 2px;
  }

  .img0 {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("/0.jpg") no-repeat center center fixed;
    background-size: cover;
    -webkit-filter: contrast(95%) brightness(95%) saturate(150%) sepia(25%)
      blur(3px);
    filter: contrast(95%) brightness(95%) saturate(150%) sepia(25%) blur(3px);
    z-index: -1;
  }
  .img1 {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("/1.jpg") no-repeat center center fixed;
    background-size: cover;
    -webkit-filter: contrast(95%) brightness(95%) saturate(150%) sepia(25%)
      blur(3px);
    filter: contrast(95%) brightness(95%) saturate(150%) sepia(25%) blur(3px);
    z-index: -1;
  }
  .img2 {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("/2.jpg") no-repeat center center fixed;
    background-size: cover;
    filter: grayscale(101%) blur(3px);
    z-index: -1;
  }
  .img3 {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("/3.jpg") no-repeat center center fixed;
    background-size: cover;
    z-index: -1;
  }
  .img4 {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("/4.jpg") no-repeat center center fixed;
    background-size: cover;
    filter: grayscale(101%) blur(3px);
    z-index: -1;
  }
  .img5 {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("/5.jpg") no-repeat center center fixed;
    background-size: cover;
    filter: grayscale(101%);
    z-index: -1;
  }
  .img5 {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("/5.jpg") no-repeat center center fixed;
    background-size: cover;
    filter: grayscale(101%);
    z-index: -1;
  }
  .img6 {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("/6.jpg") no-repeat center center fixed;
    background-size: cover;
    filter: grayscale(101%);
    z-index: -1;
  }
  .img7 {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("/7.jpg") no-repeat center center fixed;
    background-size: cover;
    filter: grayscale(101%);
    z-index: -1;
  }
  .img8 {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("/8.jpg") no-repeat center center fixed;
    background-size: cover;
    filter: grayscale(101%);
    z-index: -1;
  }
  .img9 {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("/9.jpg") no-repeat center center fixed;
    background-size: cover;
    filter: grayscale(101%);
    z-index: -1;
  }
  .img10 {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("/10.jpg") no-repeat center center fixed;
    background-size: cover;
    filter: grayscale(101%);
    z-index: -1;
  }
  .imglast {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("/last.jpg") no-repeat center center fixed;
    background-size: cover;
    filter: grayscale(101%);
    z-index: -1;
  }
</style>

<svelte:window on:keydown={handleKeydown} />
{#each [x] as count (count)}
  <div
    in:fade={{ duration: 3000 }}
    out:fade={{ duration: 3000 }}
    class="img{count}" />
{/each}
<div class="c">
  <header>
    <h2 class="dv">
      <span
        class="badge badge-pill badge-dark ar"
        style="font-weight:normal;padding:15px;">
        هل ترانا نلتقي
      </span>

    </h2>
  </header>
  <nav>
    <!-- {#if img != undefined}
      <img src={img.img} style="height:300px;" alt="" class="img-fluid rounded" />
      <h3 class="ar">{img.caption}</h3>
    {/if} -->
    {#if caption != undefined}
      {#each [...caption.data] as c}
        <br />
        <div in:fade lang={c.lang} class={c.lang}>
          <h4>{c.text}</h4>
        </div>
      {/each}
    {/if}
  </nav>
  <footer class="container-fluid">
    <div class="row">
      <div class="col-6" style="text-align:right">
        <div class="btn-group" role="group" aria-label="Basic example">
          <a
            style="color:white"
            href="/haltara.mp3"
            class="btn btn-secondary btn-sm">
            <svg
              class="bi bi-download"
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                d="M.5 8a.5.5 0 01.5.5V12a1 1 0 001 1h12a1 1 0 001-1V8.5a.5.5 0
                011 0V12a2 2 0 01-2 2H2a2 2 0 01-2-2V8.5A.5.5 0 01.5 8z"
                clip-rule="evenodd" />
              <path
                fill-rule="evenodd"
                d="M5 7.5a.5.5 0 01.707 0L8 9.793 10.293 7.5a.5.5 0
                11.707.707l-2.646 2.647a.5.5 0 01-.708 0L5 8.207A.5.5 0 015 7.5z"
                clip-rule="evenodd" />
              <path
                fill-rule="evenodd"
                d="M8 1a.5.5 0 01.5.5v8a.5.5 0 01-1 0v-8A.5.5 0 018 1z"
                clip-rule="evenodd" />
            </svg>
            &nbsp; mp3
          </a>
        </div>
      </div>

      <div class="col-6" style="text-align:left;">
        <div class="btn-group" role="group" aria-label="Basic example">
          <button type="button" class="btn btn-secondary btn-sm">
            <Modal>
              <Info />
            </Modal>
            <svg
              class="bi bi-chat-square-quote"
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                d="M14 1H2a1 1 0 00-1 1v8a1 1 0 001 1h2.5a2 2 0 011.6.8L8 14.333
                9.9 11.8a2 2 0 011.6-.8H14a1 1 0 001-1V2a1 1 0 00-1-1zM2 0a2 2 0
                00-2 2v8a2 2 0 002 2h2.5a1 1 0 01.8.4l1.9 2.533a1 1 0 001.6
                0l1.9-2.533a1 1 0 01.8-.4H14a2 2 0 002-2V2a2 2 0 00-2-2H2z"
                clip-rule="evenodd" />
              <path
                d="M7.468 5.667c0 .92-.776 1.666-1.734 1.666S4 6.587 4 5.667C4
                4.747 4.776 4 5.734 4s1.734.746 1.734 1.667z" />
              <path
                fill-rule="evenodd"
                d="M6.157 4.936a.438.438 0 01-.56.293.413.413 0
                01-.274-.527c.08-.23.23-.44.477-.546a.891.891 0
                01.698.014c.387.16.72.545.923.997.428.948.393 2.377-.942
                3.706a.446.446 0 01-.612.01.405.405 0 01-.011-.59c1.093-1.087
                1.058-2.158.77-2.794-.152-.336-.354-.514-.47-.563z"
                clip-rule="evenodd" />
              <path
                d="M11.803 5.667c0 .92-.776 1.666-1.734 1.666-.957
                0-1.734-.746-1.734-1.666 0-.92.777-1.667 1.734-1.667.958 0
                1.734.746 1.734 1.667z" />
              <path
                fill-rule="evenodd"
                d="M10.492 4.936a.438.438 0 01-.56.293.413.413 0
                01-.274-.527c.08-.23.23-.44.477-.546a.891.891 0
                01.698.014c.387.16.72.545.924.997.428.948.392 2.377-.942
                3.706a.446.446 0 01-.613.01.405.405 0 01-.011-.59c1.093-1.087
                1.058-2.158.77-2.794-.152-.336-.354-.514-.469-.563z"
                clip-rule="evenodd" />
            </svg>
          </button>

        </div>
      </div>

    </div>
    <div class="row" style="line-height:50px;">
      <div class="col">
        <!-- <Slider bind:value={second} max={length} min={0} /> -->
        <input
          type="range"
          class="custom-range"
          min="0"
          max={length}
          bind:value={second}
          on:change={jump}
          id="customRange2" />
        <button on:click={togglePlay} class="btn btn-primary btn-lg play-btn">
          {#if playing}
            <svg
              class="bi bi-pause"
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                d="M6 3.5a.5.5 0 01.5.5v8a.5.5 0 01-1 0V4a.5.5 0 01.5-.5zm4
                0a.5.5 0 01.5.5v8a.5.5 0 01-1 0V4a.5.5 0 01.5-.5z"
                clip-rule="evenodd" />
            </svg>
          {:else}
            <svg
              class="bi bi-play"
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                d="M10.804 8L5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 010
                1.392l-6.363 3.692C4.713 12.69 4 12.345 4
                11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z"
                clip-rule="evenodd" />
            </svg>
          {/if}
        </button>
      </div>
    </div>
  </footer>
</div>
